import React from "react";

export const ReportsSidebar = () => {
  return (
    <div className="ReportsSidebar">
      Reports Sidebar
    </div>
  )
}
